/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import Button from "@mui/material/Button";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { setStepDetails } from "src/redux/Actions/common";
import { setCovidNRIPostDetails } from "src/redux/Thunk";
// import regex from "src/helpers/regex";
// import CustomCheckBox from "src/shared/CustomCheckBox";
import store from "src/redux/store";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import {
  withNriValidationSchema,
  withoutNriValidationSchema
} from "src/helpers/FormDetails/ProposalDetails/CovidAndNri";
import CustomModal from "src/shared/CustomModal";
import { useState } from "react";
// import CovidForm from "./CovidForm";
// import CovidVaccine from "./CovidVaccine";
import NRIDetails from "./NRIDetails";
import TravelDetails from "./TravelDetails";
import OccupationDetails from "./OccupationDetails";
import SalaryDetails from "./SalaryDetails";
import SelfEmployeedDetails from "./SelfEmployeedDetails";
import BankDetails from "./BankDetails";
import AddressDetails from "./AddressDetails";
import InsuranceDetails from "./InsuranceDetails";

// interface Props {
//   setStepNo: any;
//   setParentStepNo: any;
// }

function CovidAndNri() {
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const covidAndNriDetails = useAppSelector((state: any) => state.covidAndNriDetails);
  // const leadId = useAppSelector((state) => state.common.leadId);
  // const tableData = useAppSelector((state) => state.dashboard.tableData);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const nationality = useAppSelector((state) => state.proposerDetails.general?.nationalityCode);
  // const parentStepNo = useAppSelector((state) => state.stepDetails?.parentStepNo);
  const proposerDoB = useAppSelector((state) => state.proposerDetails.general?.dob) || "";
  // const parentStepNo = useAppSelector((state) => state.stepDetails?.parentStepNo);
  // const isJointAddendumState = useSelector((state: any) => state.isJointAddendum);

  const getInitialValues = () => {
    const intialObj = {
      covidTest: {
        covidPositive: covidAndNriDetails.covidTest.covidPositive,
        covidQuarantine: covidAndNriDetails.covidTest.covidQuarantine || "",
        covidComplication: covidAndNriDetails.covidTest.covidComplication || ""
      },
      covidVaccineDates: {
        covidVaccinated: covidAndNriDetails.covidVaccineDates.covidVaccinated,
        dateOfFirstDose: covidAndNriDetails.covidVaccineDates.dateOfFirstDose || "",
        dateOfSecondDose: covidAndNriDetails.covidVaccineDates.dateOfSecondDose || "",
        dateOfBoosterDose: covidAndNriDetails.covidVaccineDates.dateOfBoosterDose || ""
      },
      ...(nationality !== "RES" && {
        nriDetails: {
          currentCountry: covidAndNriDetails.nriDetails.currentCountry || "",
          currentCountryCode: covidAndNriDetails.nriDetails.currentCountryCode || "",
          cityOfResidence: covidAndNriDetails.nriDetails.cityOfResidence || "",
          lastDateOfEntryToIn: covidAndNriDetails.nriDetails.lastDateOfEntryToIn || "",
          exitDateFromIndia: covidAndNriDetails.nriDetails.exitDateFromIndia || "",
          durationOfStayAbroad: covidAndNriDetails.nriDetails.durationOfStayAbroad || "",
          purposeOfStayAbroad: covidAndNriDetails.nriDetails.purposeOfStayAbroad || "",
          insurancePurpose: covidAndNriDetails.nriDetails.insurancePurpose || ""
        },
        otherCountryTravel: {
          isOtherCountryTravel: covidAndNriDetails.otherCountryTravel.isOtherCountryTravel,
          countryName: covidAndNriDetails.otherCountryTravel.countryName || "",
          countryNameCode: covidAndNriDetails.otherCountryTravel.countryNameCode || "",
          duration: covidAndNriDetails.otherCountryTravel.duration || "",
          purpose: covidAndNriDetails.otherCountryTravel.purpose || ""
        },
        occupationDetails: {
          occupationNameAndRole: covidAndNriDetails.occupationDetails.occupationNameAndRole || ""
        },
        salaried: {
          isSalaried: covidAndNriDetails.salaried.isSalaried,
          companyName: covidAndNriDetails.salaried.companyName || "",
          designation: covidAndNriDetails.salaried.designation || "",
          currency: covidAndNriDetails.salaried.currency || "Rupee",
          monthlyIncome: covidAndNriDetails.salaried.monthlyIncome || ""
        },
        selfEmployed: {
          isSelfEmployed: covidAndNriDetails.selfEmployed.isSelfEmployed,
          grossTurnover: covidAndNriDetails.selfEmployed.grossTurnover || "",
          annualIncome: covidAndNriDetails.selfEmployed.annualIncome || ""
        },
        bankDetails: {
          nameOfTheBank: covidAndNriDetails.bankDetails.nameOfTheBank || "",
          branch: covidAndNriDetails.bankDetails.branch || "",
          accountNumber: covidAndNriDetails.bankDetails.accountNumber || ""
        },
        residence: {
          nameOfTheBankResidence: covidAndNriDetails.residence.nameOfTheBankResidence || ""
        },
        policyDetails: {
          isOtherPolicyOutsideIndia: covidAndNriDetails.policyDetails.isOtherPolicyOutsideIndia,
          insurerName: covidAndNriDetails.policyDetails.insurerName || "",
          sumAssured: covidAndNriDetails.policyDetails.sumAssured || "",
          premiumAccount: covidAndNriDetails.policyDetails.premiumAccount || "",
          policyStatus: covidAndNriDetails.policyDetails.policyStatus || "",
          dateOfInsurance: covidAndNriDetails.policyDetails.dateOfInsurance || ""
        },
        addJoint: {
          isJoint: false
        }
      })
    };

    return intialObj;
  };

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: getInitialValues(),
    validationSchema:
      nationality === "RES" ? withoutNriValidationSchema() : withNriValidationSchema(proposerDoB!),
    onSubmit: async (fieldValues) => {
      // setParentStepNo(3);
      // dispatch(setStepDetails({ parentStepNo: 3 }));
      if (proposalStatus !== "MEF Submitted") {
        store.dispatch(setCovidNRIPostDetails(fieldValues, { parentStepNo: 3, jointStepNo: 1 }));
        window.scrollTo(0, 0);
      }
    }
  });
  const handleProposerCovidNriForm = () => {
    if (!formik.isValid) setModalOpen(true);
    formik.handleSubmit();
  };

  // const handleChange = (field: any) => (evt: any) => {
  //   dispatch(setCovidAndNriDetails({ field, value: evt.target.value }));
  // };
  // console.log("covid nri formik values", formik.values, formik.errors, formik.touched);
  return (
    <>
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <div className="px-10 mt-8">
        {/* Commented out the COVID section as it's no longer needed but can be reused if required. */}
        {/* <p className="font-montserrat text-base text-black font-bold mb-6">Covid Details</p>
        <CovidForm formik={formik} />
        <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
        <CovidVaccine formik={formik} />
        <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" /> */}
        {nationality !== "RES" && (
          <div>
            <NRIDetails formik={formik} dob={proposerDoB!} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <TravelDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <OccupationDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <SalaryDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <SelfEmployeedDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <BankDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <AddressDetails formik={formik} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
            <InsuranceDetails formik={formik} dob={proposerDoB!} />
            <hr className="border-dashed border-t-1 my-8 border-black  opacity-50" />
          </div>
        )}
        {/* <div>
      <CustomCheckBox
        label="Add Joint Life Addendum"
        name="existingPolicy.existingLifeCover"
        handleBlur={formik.handleBlur}
        setFieldValue={formik.setFieldValue}
      />
    </div> */}
        <div className="flex items-center justify-center">
          <Button
            onClick={() => {
              dispatch(setStepDetails({ proposerStepNo: 4 }));
              window.scrollTo(0, 0);
            }}
            classes={{ outlined: "!rounded-lg" }}
            variant="outlined"
            className="!text-black !uppercase h-13 w-37.5 rounded-xl !mr-10"
          >
            Back
          </Button>
          <Button
            onClick={handleProposerCovidNriForm}
            variant="contained"
            classes={{ contained: "!rounded-lg" }}
            className="!uppercase h-13 w-37.5"
          >
            Next
          </Button>
        </div>
      </div>
    </>
  );
}

export default CovidAndNri;
